import { BodyMovin, Div, H1 } from '@driftt/tide-core'
import React from 'react'

import DIZZY_BOT from './dizzy-bot-404.json'

import './style.css'

const BODYMOVIN_OPTIONS = {
  loop: true,
  autoplay: true,
  prerender: true,
  renderer: 'svg',
  animationData: DIZZY_BOT,
}

const NotFoundPage = () => (
  <Div className="not-found-page">
    <Div className="not-found-animation">
      <BodyMovin options={BODYMOVIN_OPTIONS} />
    </Div>
    <H1 className="not-found-header">Oh man, you stumped DriftBot!</H1>
    <span role="img" aria-label="page-not-found" className="not-found-subtext">
      We can’t seem to find what you’re looking for…maybe it’s time for a reboot
      🙈
    </span>
  </Div>
)

export default NotFoundPage
